import React from 'react';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import Button from '@/ui/components/shared/Button';
import Checkmark from '../../../../../../public/images/checkmark-yellow-black-border.svg';
import formatPunctuation from '@/ui/utils/formatPunctuation';

export default function ExitPage(props: { components: any }) {
  const { components } = props;
  console.log(components);
  const headline = components.find((c: any) => c.id === 'headline');
  const icon = components.find((c: any) => c.id === 'icon');
  const text = components.find((c: any) => c.id === 'text');

  return (
    <div className="flex justify-center">
      <div className="max-w-[56rem] overflow-y-hidden px-6 py-15">
        <div className="mb-8 flex justify-center">
          <Image
            src={icon.content.firstImage.url}
            alt={icon.content.firstImage.alt}
            width={32}
            height={32}
            className="h-14 w-14 sm:h-20 sm:w-20"
          />
        </div>
        <div className="text-center">
          <h1 className="mb-8 text-xl font-bold sm:text-4xl">
            {formatPunctuation(headline.content.text)}
          </h1>
          <div className="sm:text-lg">
            {
              text.content.json.map((t: any) => (
                t.type === 'paragraph' ? (
                  <p className="pb-5">{t.textContent}</p>
                ) : <p>&nbsp</p>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}
